import { render, staticRenderFns } from "./personnel.vue?vue&type=template&id=3d21da1a&scoped=true"
import script from "./personnel.vue?vue&type=script&lang=js"
export * from "./personnel.vue?vue&type=script&lang=js"
import style0 from "./personnel.vue?vue&type=style&index=0&id=3d21da1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d21da1a",
  null
  
)

export default component.exports